export const qlist = [
  {
    id: 1,
    question: "您的年齡？",
    answers: {
      a: "18歲以下",
      b: "18歲-25歲",
      c: "26歲-35歲",
      d: "36歲-45歲",
      e: "45歲-55歲",
      f: "55歲以上",
    },
  },
  {
    id: 2,
    question:
      "請問車手在《巔峰極速》大概儲值過多少金額？",
    answers: {
      a: "NT 1,000以下",
      b: "NT 1,001 ~ NT 10,000",
      c: "NT 10,001 ~ NT 30,000",
      d: "NT 30,001 ~ NT 50,000",
      e: "NT 50,000 以上",
      f: "無儲值經驗",
    },
  },
  {
    id: 3,
    question: "車手最常使用的支付方式？",
    answers: {
      a: "信用卡",
      b: "小額帳單",
      c: "電子支付 (如 LINE PAY、街口...)",
      d: "銀行轉帳",
      e: "MyCard點卡",
      f: "官方儲值網站",
      g: "代儲",
      h: "無儲值經驗",
      i: "其他",
    },
  },
  {
    id: 4,
    question: "最常購買的遊戲內商品？",
    answers: {
      a: "月卡、合約",
      b: "商店禮包、神秘商店",
      c: "車輛卡池抽車",
      d: "角色時裝獎池、聯動獎池",
      e: "無儲值經驗",
      f: "其他",
    },
  },
];
